<template>
    <v-ons-toolbar>
        <div v-if="back" class="left zindex9">
            <v-ons-back-button material></v-ons-back-button>
        </div>
        <div :class="{'text-center minus7-ml':'!back' }" class="center zindex1">
            <slot> {{ $t("message.title") }}</slot>
            <!--<slot v-if="!title"> TABLAS DE LA CATEDRAL DE SEGOVIA </slot>-->
        </div>
    </v-ons-toolbar>
</template>

<script>


    const log = function (args) {
        console.log(args);
    }
    export default {
        name: 'TopBar',
        methods: {log},
        props: [
            'back'
        ]
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import '../assets/css/styles.css';

    .zindex9 {
        z-index: 99;
    }
    .zindex1 {
        z-index: 1;
    }
    .text-center {
        text-align: center;
    }

    .toolbar__title {
        font-size: 3.75vw;
    }

    .toolbar__left {
        width: 21%;
    }

    .toolbar--material__left {
        width: 15%;
    }

    .toolbar {
        height: auto;
        min-height:56px;
        padding-top: 7% !important;
    }

    @media (min-width: 800px) {
        .toolbar {
            padding-top: 30px !important;
        }

    }





</style>



// WEBPACK FOOTER //
// src/components/TopBar.vue